<template>
  <div>
    <Cabecera :hamburguer="true" />

    <slot name="banner" />

    <div class="contenedor">
      <div class="menulateral">
        <!--menu contextual va aqui dentro -->
        <slot name="menu" />
      </div>

      <div class="contenido">
        <!-- aqui va el contenido principal de la pagina -->
        <slot name="contenido" />
      </div>
    </div>

    <SiguenosEn />
    <Pie />

    <BotonAtras />
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.contenedor {
  display: flex;
  flex-flow: row wrap;
}

.contenido {
  flex-grow: 6;
}

.menulateral {
  border-right: 1px solid $colorMMT;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 10px;
  flex-grow: 1;
  background-color: $azulOscuroMMT;
  min-width: 250px;
  flex: 1 0 calc(25%);
  // flex: 1 1 25%;
}

@media screen and (min-width: 768px) {
  .contenedor {
    flex-flow: row nowrap;
  }
}

.backContainer {
  display: flex;
  justify-content: center;
}
</style>
